import { render, staticRenderFns } from "./CouponInfo.vue?vue&type=template&id=3a9454e7&scoped=true"
import script from "./CouponInfo.vue?vue&type=script&lang=js"
export * from "./CouponInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a9454e7",
  null
  
)

export default component.exports